import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { css } from "styled-components"
import { Grid, Block, Spacer } from "../../atoms/layout-primitives"
import BreakpointImage from "../../atoms/breakpoint-image"
import Text from "../../atoms/text"
import { T } from "../../styles/typography"
import IconTitleCard from "../../molecules/icon-title-card"
import { Alignments } from "../../molecules/icon-title"
import Button from "../../atoms/button"

export default function Overview(props) {
  const query = useStaticQuery(graphql`
    query {
      enterpriseDesktop: file(
        relativePath: { eq: "4_COMPANY/Security/enterprise grade - desk.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      enterpriseImage: file(
        relativePath: { eq: "4_COMPANY/Security/enterprise grade.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      clipboardIcon: file(
        relativePath: { eq: "4_COMPANY/Security/icons/icon 01.svg" }
      ) {
        publicURL
      }
      houseIcon: file(
        relativePath: { eq: "4_COMPANY/Security/icons/icon 02.svg" }
      ) {
        publicURL
      }
      eyeIcon: file(
        relativePath: { eq: "4_COMPANY/Security/icons/icon 03.svg" }
      ) {
        publicURL
      }
    }
  `)

  return (
    <>
      <Grid>
        <Spacer height={{ sm: "48px", md: "48px", lg: "96px" }} />
        <Block col={{ sm: "1 / -1", md: "3 / -3", lg: "1 / 7" }}>
          <BreakpointImage
            imageVariants={{
              sm: query.enterpriseImage.childImageSharp.fluid,
              md: query.enterpriseImage.childImageSharp.fluid,
              lg: query.enterpriseDesktop.childImageSharp.fluid,
            }}
          />
        </Block>
        <Spacer
          height={{ sm: "32px", md: "48px", lg: "0px" }}
          display={{ lg: "none" }}
        />
        <Block
          col={{ sm: "1 / -1", md: "2 / -2", lg: "8 / -1" }}
          variants={[
            css`
              text-align: center;
            `,
            css``,
            css`
              text-align: left;
              align-self: center;
            `,
          ]}
        >
          <Text
            variants={[
              css`
                ${T.sm.h2`500`}
                letter-spacing: 0.05em;
                color: var(--slate);
              `,
              css`
                ${T.md.h2`500`}
                letter-spacing: 0.08em;
              `,
              css`
                ${T.lg.h2`500`}
              `,
            ]}
          >
            Enterprise Grade, International Compliance
          </Text>
        </Block>
        <Block
          display={{sm: 'grid', md: 'grid', lg: 'grid'}}
          col={{ sm: "1 / -1", md: "3 / -3", lg: "1 / -1" }}
          variants={[
            css`
              grid-template-columns: 1fr;
              grid-column: 1 / -1;
              width: 100%;
            `,
            null,
            css`
              grid-template-columns: 1fr 1fr;
              grid-gap: 48px;
            `,
          ]}
        >
          <IconTitleCard
            icon={
              <img src={query.clipboardIcon.publicURL} alt="Clipboard Icon" />
            }
            title="SOC2 Type 1 Report"
            description="Mappedin’s SOC 2 (Type 1) report showcases our enterprise-grade system and organization controls regarding security, privacy, availability, and confidentiality of data. Contact our team to get a copy of the report."
            titleVariants={[
              css`
                margin-top: 48px;
                ${T.sm.h4`500`}
              `,
              css`
                ${T.md.h4`500`}
              `,
              css`
                margin-top: 96px;
                ${T.lg.h4`500`}
              `,
            ]}
            descriptionVariants={{ sm: { textAlign: "center" } }}
            titleAlignmentVariants={[
              Alignments["row-center"],
              Alignments["row-center"],
              Alignments["column-centered"],
            ]}
            iconVariants={{
              sm: { width: "24px", height: "24px" },
              lg: { width: "48px", height: "48px" },
            }}
          />
          {/*
          <IconTitleCard
            icon={<img src={query.houseIcon.publicURL} alt="House Icon" />}
            title="Pipeda Compliance"
            description="Mappedin is compliant with the Personal Information Protection and Electronic Documents Act (PIPEDA). This act is a Canadian law relating to data privacy and governs how private sector organizations collect, use and disclose personal information. Mappedin is in the process of becoming fully GDPR compliant."
            titleVariants={[
              css`
                margin-top: 48px;
                ${T.sm.h4`500`}
                margin-left: auto;
                margin-right: auto;
              `,
              css`
                ${T.md.h4`500`}
              `,
              css`
                margin-top: 96px;
                ${T.lg.h4`500`}
              `,
            ]}
            descriptionVariants={{ sm: { textAlign: "center" } }}
            titleAlignmentVariants={[
              Alignments["row-left"],
              Alignments["row-left"],
              Alignments["column-centered"],
            ]}
            iconVariants={{
              sm: { width: "24px", height: "24px" },
              lg: { width: "48px", height: "48px" },
            }}
          />
          */}
          <IconTitleCard
            icon={<img src={query.eyeIcon.publicURL} alt="Eye Icon" />}
            title="Product Pen Testing"
            description="Mappedin has undergone Penetration Testing on all of its core applications. As a commitment to guaranteed uptimes and continued scale of our products, it is imperative that our products are performant and secure. Contact our team to learn more about our penetration testing outcomes."
            titleVariants={[
              css`
                margin-top: 48px;
                ${T.sm.h4`500`}
              `,
              css`
                ${T.md.h4`500`}
              `,
              css`
                margin-top: 96px;
                ${T.lg.h4`500`}
              `,
            ]}
            descriptionVariants={{ sm: { textAlign: "center" } }}
            titleAlignmentVariants={[
              Alignments["row-center"],
              Alignments["row-center"],
              Alignments["column-centered"],
            ]}
            iconVariants={{
              sm: { width: "24px", height: "24px" },
              lg: { width: "48px", height: "48px" },
            }}
          />
        </Block>
        <Button.ScrollLink
          to="contact-form"
          smooth
          duration={1000}
          variants={{
            sm: {
              gridColumn: "2 / -2",
              justifySelf: "center",
              marginTop: "32px",
            },
            md: {
              marginTop: "48px"
            },
            lg: {
              paddingLeft: 0,
              paddingRight: 0,
              maxWidth: "181px",
              maxHeight: "46px"
            }
          }}
        >
          Book A Demo
        </Button.ScrollLink>
        <Spacer height={{ sm: "48px", md: "48px", lg: "96px" }} />
      </Grid>
    </>
  )
}
